/**
 * Compute a minimal PATCH body: only keys whose value changed from the last-loaded server
 * state (spec §5.5 — partial diffs, no view-state leakage). Deep-equal by JSON for nested
 * objects (doc/seo). `doc` is sent whole when changed (server replaces it).
 */
export function diffPatch<T extends Record<string, unknown>>(
  original: T,
  current: T,
): Partial<T> {
  const out: Partial<T> = {};
  for (const key of Object.keys(current) as (keyof T)[]) {
    const a = original[key];
    const b = current[key];
    if (!deepEqual(a, b)) out[key] = b;
  }
  return out;
}

export function deepEqual(a: unknown, b: unknown): boolean {
  if (a === b) return true;
  if (a == null || b == null) return a === b;
  if (typeof a !== typeof b) return false;
  if (typeof a !== 'object') return false;
  return JSON.stringify(a) === JSON.stringify(b);
}

export function isDirty<T extends Record<string, unknown>>(original: T, current: T): boolean {
  return Object.keys(diffPatch(original, current)).length > 0;
}
